import script from "./InfoModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoModal.vue?vue&type=script&lang=ts&setup=true"

import "./InfoModal.vue?vue&type=style&index=0&id=0662b821&lang=scss"

const __exports__ = script;

export default __exports__